import { Spin, Tag } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";
import Apiauth from "../../api/Apiauth";
import { logout } from "../../config/authsave";
// import { calculateAccountUsage } from "../../helpers/calculate";
import config from "../../config/app.config";
import { getRoleDisplayName, updateNetwork } from "../../utils";
import { withTranslation } from "react-i18next";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
// import { calculateTimeDifference, FormatTimeAgo } from "../../helpers/formatTimeAgo";

class ProfileV1Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      currentPassword: "",
      isChangingPassword: false,
    };
  }
  componentDidMount() {
    updateNetwork();
  }
  handlePasswordInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleChangePassword = async () => {
    const { newPassword, confirmPassword, currentPassword } = this.state;
    const { openNotification, history, t } = this.props;
    if (!newPassword || !confirmPassword || !currentPassword) {
      openNotification("error", t("เกิดข้อผิดพลาด"), t("โปรดกรอกข้อมูลให้ครบ"));
      return;
    }
    if (newPassword !== confirmPassword) {
      openNotification(
        "error",
        t("เกิดข้อผิดพลาด"),
        t("รหัสผ่านใหม่และยืนยันรหัสผ่านไม่ตรงกัน"),
      );
      return;
    }
    this.setState({
      isChangingPassword: true,
    });
    try {
      Apiauth.postChangPassword({
        currentPassword: currentPassword,
        confirmPassword: confirmPassword,
        newPassword: newPassword,
      })
        .then((res) => {
          if (res.data.success) {
            this.setState({
              newPassword: "",
              confirmPassword: "",
            });
            openNotification(
              "success",
              "successfully",
              t("อัปเดตรหัสผ่านสำเร็จแล้ว"),
            );
            setTimeout(() => {
              if (window.confirm(t("ออกจากระบบตอนนี้หรือไม่?"))) {
                logout();
                history.push("/login");
              } else {
              }
            }, 1500);
          } else {
            openNotification(
              "error",
              t("เกิดข้อผิดพลาด"),
              res?.data?.message ||
                t("ไม่สามารถอัปเดตรหัสผ่านได้ โปรดลองอีกครั้ง."),
            );
          }
        })
        .catch((err) => {
          openNotification(
            "error",
            "error",
            `${t("เกิดข้อผิดพลาด")} error: ${err.status}`,
          );
        });
    } catch (error) {
      openNotification(
        "error",
        "error",
        `${t("เกิดข้อผิดพลาด")} error: ${error.status}`,
      );
    } finally {
      setTimeout(() => {
        this.setState({ isChangingPassword: false });
      }, 1000);
    }
  };
  render() {
    const { resProfileAdmin, t ,  isMerchantData} = this.props;
    let userInfo = resProfileAdmin;
    let r =
      userInfo?.role?.length > 14
        ? userInfo?.role.substring(0, 14)
        : userInfo?.role;

    const {
      newPassword,
      confirmPassword,
      currentPassword,
      isChangingPassword,
    } = this.state;
   
    let merchant = isMerchantData;
    return (
      <Spin spinning={isChangingPassword}>
        <div className="body">
          <h6></h6>{" "}
          <div className="media">
            <div className="media-left ">
              <img
                alt="User"
                height={100}
                className="user-photo media-object"
                src={this.props.UserImage}
              />
            </div>
            <div className="media-body">
              <p className="" style={{ marginLeft: "13px" }}>
                <strong>
                  {t("username")}:{" "}
                  <code style={{ color: "#888" }}>{userInfo?.username}</code>{" "}
                  {userInfo?.admin_type ? (
                    <small style={{ fontSize: 10 }}>
                      ({userInfo?.admin_type})
                    </small>
                  ) : null}
                </strong>{" "}
                <br />
                <strong>
                  {t("Roles")}:{" "}
                  <code style={{ color: "#888" }}>
                    {getRoleDisplayName(userInfo, r) || "null"}
                  </code>
                </strong>{" "}
                <br />
                <strong>
                  {t("status")}:{" "}
                  <Tag
                    color={userInfo?.admin_status === 1 ? "success" : "error"}
                  >
                    {userInfo?.admin_status === 1 ? t("Active") : t("Inactive")}
                  </Tag>
                </strong>{" "}
                <br />
                <strong>
                  {t("IP Address")}:{" "}
                  <code style={{ color: "#888" }}>{userInfo?.IP || "-"}</code>
                </strong>{" "}
                <br />
                <strong>
                  {t("Network")}: <span id="networks"></span>
                </strong>{" "}
                <br />
                <strong>
                  {t("createdAt")}:{" "}
                  <code style={{ color: "#888" }}>
                    {moment(userInfo?.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  </code>
                </strong>{" "}
                <br />
                <strong>
                  {t("Last login")}:{" "}
                  <code style={{ color: "#888" }}>
                    {FormatTimeAgo(userInfo?.updated_at)}
                  </code>
                </strong>{" "}
                <br />
                <hr style={{ width: "100%" }} />
                <strong>
                  {t("ผู้ให้บริการ")}:{" "}
                  <code style={{ color: "#888" }}>{config.web_name}</code>
                </strong>{" "}
                <br />
                <strong>
                  {t("Merchant")}:{" "}
                  <code style={{ color: "#888" }}>{merchant?.name}</code>
                </strong>{" "}
                <br />
                <strong>
                  {t("Status")}:{" "}
                  <code>
                    <Tag color={merchant?.isActive ? "success" : "error"}>
                      {merchant
                        ? merchant?.isActive
                          ? t("Active")
                          : t("Inactive")
                        : "-"}
                    </Tag>
                  </code>
                </strong>{" "}
              </p>
            </div>
          </div>
        </div>
        {/* Change Password */}
        <div className="body">
          <h6>{t("Change Password")}</h6>
          <div className="row clearfix">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    {t("Current Password")}
                  </span>
                </div>
                <input
                  type="password"
                  className="form-control"
                  name="currentPassword"
                  value={currentPassword}
                  onChange={this.handlePasswordInputChange}
                  placeholder={t("Enter Current Password")}
                />
              </div>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">{t("New Password")}</span>
                </div>
                <input
                  type="password"
                  className="form-control"
                  name="newPassword"
                  value={newPassword}
                  onChange={this.handlePasswordInputChange}
                  placeholder={t("Enter New Password")}
                />
              </div>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    {t("Confirm Password")}
                  </span>
                </div>
                <input
                  type="password"
                  className="form-control"
                  name="confirmPassword"
                  value={confirmPassword}
                  onChange={this.handlePasswordInputChange}
                  placeholder={t("Enter Confirm New Password")}
                />
              </div>
            </div>
          </div>
          <br />
          <button
            className="btn btn-primary"
            type="button"
            onClick={this.handleChangePassword}
            disabled={isChangingPassword}
          >
            {isChangingPassword ? t("Updating...") : t("Update Password")}
          </button>{" "}
          &nbsp;&nbsp;
          <button
            className="btn btn-default"
            type="button"
            onClick={() =>
              this.setState({
                newPassword: "",
                confirmPassword: "",
                passwordChangeError: null,
                passwordChangeSuccess: null,
              })
            }
            disabled={isChangingPassword}
          >
            {t("Cancel")}
          </button>
          <br />
        </div>
      </Spin>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(
  mapStateToProps,
  {},
)(withTranslation()(ProfileV1Setting));
